/* Pastel Boutique — Theme JS */

(function () {
  'use strict';

  var CART_TYPE = (document.body.dataset.cartType || 'page').toLowerCase();

  // ===== Cart drawer =====
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var openers = document.querySelectorAll('[data-cart-open]');
  var closers = document.querySelectorAll('[data-cart-close]');

  function openCart(e) {
    if (CART_TYPE !== 'drawer' || !drawer) return;
    if (e) e.preventDefault();
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  Array.prototype.forEach.call(openers, function (el) {
    el.addEventListener('click', openCart);
  });
  Array.prototype.forEach.call(closers, function (el) {
    el.addEventListener('click', closeCart);
  });
  if (overlay) overlay.addEventListener('click', closeCart);

  // ===== Product gallery =====
  Array.prototype.forEach.call(document.querySelectorAll('[data-product-gallery]'), function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.src;
        var alt = thumb.dataset.alt || '';
        if (main && src) {
          main.src = src;
          main.alt = alt;
        }
        Array.prototype.forEach.call(thumbs, function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  // ===== Quantity controls =====
  Array.prototype.forEach.call(document.querySelectorAll('[data-quantity]'), function (wrap) {
    var input = wrap.querySelector('input');
    if (!input) return;
    Array.prototype.forEach.call(wrap.querySelectorAll('[data-quantity-change]'), function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.dataset.quantityChange, 10);
        var val = parseInt(input.value, 10) || 1;
        val = Math.max(1, val + dir);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // ===== Add to cart =====
  Array.prototype.forEach.call(document.querySelectorAll('[data-product-form]'), function (form) {
    if (CART_TYPE !== 'drawer') return;

    form.addEventListener('submit', function (e) {
      if (typeof window.fetch !== 'function') return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = 'Adding…';
      }

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () { return updateCart(); })
        .then(function () { openCart(); })
        .catch(function () { form.submit(); })
        .then(function () {
          if (btn) {
            btn.disabled = false;
            btn.innerHTML = original;
          }
        });
    });
  });

  function updateCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  // ===== Mobile nav drawer =====
  var mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileNavOverlay = document.querySelector('.mobile-nav__overlay');
  var mobileNavClosers = document.querySelectorAll('[data-mobile-nav-close]');

  function openMobileNav() {
    if (mobileNav) mobileNav.classList.add('is-open');
    if (mobileNavOverlay) mobileNavOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (mobileNav) mobileNav.classList.remove('is-open');
    if (mobileNavOverlay) mobileNavOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', openMobileNav);
  }
  Array.prototype.forEach.call(mobileNavClosers, function (el) {
    el.addEventListener('click', closeMobileNav);
  });

  // ===== Announcement slider =====
  var announcements = document.querySelectorAll('[data-announcement-slide]');
  if (announcements.length > 1) {
    var idx = 0;
    Array.prototype.forEach.call(announcements, function (s, i) {
      s.style.display = i === 0 ? '' : 'none';
    });
    setInterval(function () {
      announcements[idx].style.display = 'none';
      idx = (idx + 1) % announcements.length;
      announcements[idx].style.display = '';
    }, 5000);
  }

  // ===== Remove item from cart (AJAX) =====
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cart-remove]');
    if (!link) return;

    e.preventDefault();
    var href = link.getAttribute('href');
    if (!href) return;

    var match = href.match(/line=(\d+)/);
    if (!match) return;
    var line = parseInt(match[1], 10);

    link.style.opacity = '0.5';
    link.style.pointerEvents = 'none';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Remove failed');
        return r.json();
      })
      .then(function (cart) {
        return fetch(window.location.pathname).then(function (pageRes) {
          return pageRes.text().then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;

            var newDrawerBody = tmp.querySelector('[data-cart-drawer-body]');
            var oldDrawerBody = document.querySelector('[data-cart-drawer-body]');
            if (newDrawerBody && oldDrawerBody) {
              oldDrawerBody.innerHTML = newDrawerBody.innerHTML;
            }

            Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
              el.textContent = cart.item_count;
            });

            if (window.location.pathname.indexOf('/cart') === 0) {
              window.location.reload();
            }
          });
        });
      })
      .catch(function () {
        window.location.href = href;
      });
  });

})();